<template>
  <div class="d-flex t-center">
    <img class="img-re" src="../../../assets/logo.png" alt="Logo">
    <span class="login100-form-title p-b-41">
      Registro
    </span>
    <img class="img-re" src="../../../assets/logo.png" alt="Logo">
  </div>

  <form class="login100-form validate-form p-b-33 p-t-5" @submit.prevent="onSubmit">
    <div class="wrap-input100 validate-input" data-validate="Ingrese su nombre">
      <input v-model="usuario.name" class="input100" type="text" placeholder="Nombre" required>
      <span class="focus-input100" data-placeholder="&#xe82a;"></span>
    </div>

    <div class="wrap-input100 validate-input" data-validate="Ingrese correo">
      <input v-model="usuario.email" class="input100" type="email" placeholder="Correo" required>
      <span class="focus-input100" data-placeholder="&#xe818;"></span>
    </div>

    <div class="wrap-input100 validate-input" data-validate="Ingrese contrasena">
      <input
        v-model="usuario.password"
        class="input100"
        type="password"
        placeholder="Contrasena"
        autocomplete="current-password"
        required
      >
      <span class="focus-input100" data-placeholder="&#xe80f;"></span>
    </div>

    <div class="container-login100-form-btn m-t-32">
      <button type="submit" class="login100-form-btn">
        Crear cuenta
      </button>
    </div>
  </form>

  <div class="container-login100-form-btn auth-actions m-t-32">
    <button type="button" @click="goToLogin" class="login100-form-btn">
      Ir a login
    </button>
    <button type="button" @click="goBack" class="login100-form-btn login100-form-btn--ghost">
      Volver
    </button>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import useAuth from '../composables/useAuth'
import Swal from 'sweetalert2'

export default {
  setup() {
    const router = useRouter()
    const { createUser, logout } = useAuth()

    const usuario = ref({
      name: '',
      email: '',
      password: ''
    })

    return {
      usuario,
      goToLogin: () => {
        logout()
        router.push({ name: 'login' })
      },
      goBack: () => {
        router.push({ name: 'login' })
      },
      onSubmit: async () => {
        const { ok, message } = await createUser(usuario.value)

        if (!ok) {
          Swal.fire('Error', message || 'No se pudo crear la cuenta', 'error')
          return
        }

        router.push({ name: 'list' })
        Swal.fire('Creado exitosamente', 'Exito', 'success')
      }
    }
  }
}
</script>

<style scoped>
.img-re {
  width: 80px;
  height: 55px;
}

.t-center {
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.auth-actions {
  gap: 0.75rem;
  flex-wrap: wrap;
}

.login100-form-btn--ghost {
  background: #dff8fe;
  color: #089fbe;
}
</style>
